<i18n locale="en">
{
  "empty-title": "Photo"
}
</i18n>

<template>
  <PreviewSheet background="primary" radius="0" class="image-preview px-4 py-3">
    <PreviewSheet class="overflow-hidden" :placeholder="!content.data">
      <a
        v-if="content.data?.image && content.data?.link"
        :href="content.data.link"
        target="_blank"
        rel="noopener noreferrer"
        :aria-label="t('empty-title')"
      >
        <img class="image-preview__image" :src="content.data.image" />
      </a>
      <img
        v-else-if="content.data?.image"
        class="image-preview__image"
        :src="content.data.image"
      />
      <PreviewSheet
        v-else
        background="secondary"
        class="pa-6 align-center h-full w-full flex-col justify-center"
      >
        <PreviewIcon color="secondary" size="24" :icon="emptyIcon" />
        <PreviewTypography
          :text="t('empty-title')"
          color="secondary"
          variant="paragraphSmall"
        />
      </PreviewSheet>
    </PreviewSheet>
  </PreviewSheet>
</template>

<script>
import { PhImageSquare } from '@phosphor-icons/vue'
import { markRaw } from 'vue'
import { useI18n } from 'vue-i18n'

import PreviewIcon from '@/lib/builder/public/preview/PreviewIcon.vue'
import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'
import PreviewTypography from '@/lib/builder/public/preview/PreviewTypography.vue'

export default {
  name: 'ImagePreview',
  components: {
    PreviewIcon,
    PreviewSheet,
    PreviewTypography,
  },
  props: {
    content: { type: Object, required: true },
  },
  setup() {
    const { t } = useI18n()

    return { t }
  },
  data() {
    return {
      emptyIcon: markRaw(PhImageSquare),
      isLoading: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.image-preview {
  &__image {
    width: 100%;
    border-radius: 16px;
    object-fit: scale-down;
  }
}
</style>
